import React, { ReactNode } from "react";
import { Flex, FlexItem } from "../compositeComponents/FlexHelpers";
import { Button } from "../button/Button";

type CollapsiblePanelHeaderProps = {
    isOpen: boolean,
    openHeader?: ReactNode,
    closedOrDefaultHeader: ReactNode,
    headerAlignment?: 'flex-start' | 'space-between' | 'flex-end'
    onChangeOpenState: (open:boolean) => void
}

export function CollapsiblePanelHeader(props: CollapsiblePanelHeaderProps): JSX.Element {

    const aligment = props.headerAlignment || 'space-between';

    return (
        <Flex justifyContent={aligment} alignItems="center">
                
            <FlexItem style={{justifyContent:'flex-end', flexGrow:'1'}}>
                {props.isOpen ? (props.openHeader ? props.openHeader : props.closedOrDefaultHeader) : props.closedOrDefaultHeader}
            </FlexItem>
            
            <Button 
                variant="text" 
                onClick = {() => {
                    const newOpen = !props.isOpen;
                    props.onChangeOpenState(newOpen);
                }}
                icon={props.isOpen ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown'} />
        </Flex>

        
    )
}